import {http} from '../../shared/services';

export const ACTIVATE_ACCOUNT = 'ACTIVATE_ACCOUNT';
export const ACTIVATE_ACCOUNT_PENDING = `${ACTIVATE_ACCOUNT}_PENDING`;
export const ACTIVATE_ACCOUNT_FULFILLED = `${ACTIVATE_ACCOUNT}_FULFILLED`;
export const ACTIVATE_ACCOUNT_REJECTED = `${ACTIVATE_ACCOUNT}_REJECTED`;

export function activateAccount(model) {
  return {
    type: ACTIVATE_ACCOUNT,
    payload: http.put(`user_account_activation/${model.get('userId')}`, model.toJS()),
  };
}



// WEBPACK FOOTER //
// ./app/features/authentication/actions/activateAccount.js